/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Processing_Notice_TextInputs */

const en_ai_processing_notice_text = /** @type {(inputs: Ai_Processing_Notice_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI/LLM models process the candidate and job-application data you provide. Review and edit outputs before use; Alchema does not make automated hiring or employment decisions.`)
};

const de_ai_processing_notice_text = /** @type {(inputs: Ai_Processing_Notice_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI/LLM-Modelle verarbeiten die von Ihnen bereitgestellten Kandidaten- und Bewerbungsdaten. Pruefen und bearbeiten Sie Ausgaben vor der Verwendung; Alchema trifft keine automatisierten Einstellungs- oder Beschaeftigungsentscheidungen.`)
};

const fr_ai_processing_notice_text = /** @type {(inputs: Ai_Processing_Notice_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des modeles IA/LLM traitent les donnees de candidature et de demande d'emploi que vous fournissez. Relisez et modifiez les resultats avant utilisation ; Alchema ne prend pas de decisions automatisees d'embauche ou d'emploi.`)
};

const es_ai_processing_notice_text = /** @type {(inputs: Ai_Processing_Notice_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los modelos de IA/LLM procesan los datos de candidatura y solicitud que proporcionas. Revisa y edita los resultados antes de usarlos; Alchema no toma decisiones automatizadas de contratación o empleo.`)
};

const it_ai_processing_notice_text = /** @type {(inputs: Ai_Processing_Notice_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I modelli IA/LLM elaborano i dati del candidato e della candidatura che fornisci. Rivedi e modifica gli output prima dell'uso; Alchema non prende decisioni automatizzate di assunzione o impiego.`)
};

const nl_ai_processing_notice_text = /** @type {(inputs: Ai_Processing_Notice_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI/LLM-modellen verwerken de kandidaat- en sollicitatiegegevens die je verstrekt. Controleer en bewerk output voor gebruik; Alchema neemt geen geautomatiseerde aanwervings- of arbeidsbeslissingen.`)
};

const pl_ai_processing_notice_text = /** @type {(inputs: Ai_Processing_Notice_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modele AI/LLM przetwarzaja podane przez Ciebie dane kandydata i aplikacji. Sprawdz i edytuj wyniki przed uzyciem; Alchema nie podejmuje zautomatyzowanych decyzji o zatrudnieniu ani pracy.`)
};

const fi_ai_processing_notice_text = /** @type {(inputs: Ai_Processing_Notice_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI/LLM-mallit kasittelevat antamiasi hakija- ja tyohakemustietoja. Tarkista ja muokkaa tulokset ennen kayttoa; Alchema ei tee automatisoituja palkkaus- tai tyollisyyspaatoksia.`)
};

const da_ai_processing_notice_text = /** @type {(inputs: Ai_Processing_Notice_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI/LLM-modeller behandler de kandidat- og jobansoegningsdata, du giver. Gennemgaa og rediger output foer brug; Alchema traever ikke automatiserede ansettelses- eller beskaeftigelsesbeslutninger.`)
};

const sv_ai_processing_notice_text = /** @type {(inputs: Ai_Processing_Notice_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI/LLM-modeller behandlar de kandidat- och jobbansokningsdata du tillhandahaller. Granska och redigera output fore anvandning; Alchema fattar inga automatiserade anstallnings- eller sysselsattningsbeslut.`)
};

/**
* | output |
* | --- |
* | "AI/LLM models process the candidate and job-application data you provide. Review and edit outputs before use; Alchema does not make automated hiring or emplo..." |
*
* @param {Ai_Processing_Notice_TextInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ai_processing_notice_text = /** @type {((inputs?: Ai_Processing_Notice_TextInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Processing_Notice_TextInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_processing_notice_text(inputs)
	if (locale === "fr") return fr_ai_processing_notice_text(inputs)
	if (locale === "es") return es_ai_processing_notice_text(inputs)
	if (locale === "it") return it_ai_processing_notice_text(inputs)
	if (locale === "nl") return nl_ai_processing_notice_text(inputs)
	if (locale === "pl") return pl_ai_processing_notice_text(inputs)
	if (locale === "fi") return fi_ai_processing_notice_text(inputs)
	if (locale === "da") return da_ai_processing_notice_text(inputs)
	if (locale === "sv") return sv_ai_processing_notice_text(inputs)
	return en_ai_processing_notice_text(inputs)
});